<template>
<div class="chapter">
<div class="inner_page">
<p class="image1"><a id="ch00_fm02"></a><a id="page_ii"><img alt="images" src="images/halftitle.jpg"/></a></p><a id="page_ii">
<p class="noindent">#1 Without a Trace</p>
<p class="noindent">#2 A Race Against Time</p>
<p class="noindent">#3 False Notes</p>
<p class="noindent">#4 High Risk</p>
<p class="noindent">#5 Lights, Camera . . .</p>
<p class="noindent">#6 Action!</p>
<p class="noindent">#7 The Stolen Relic</p>
<p class="noindent">#8 The Scarlet Macaw Scandal</p>
<p class="noindent">#9 Secret of the Spa</p>
<p class="noindent">#10 Uncivil Acts</p>
<p class="noindent">#11 Riverboat Ruse</p>
<p class="noindent">#12 Stop the Clock</p>
<p class="noindent">#13 Trade Wind Danger</p>
<p class="noindent">#14 Bad Times, Big Crimes</p>
<p class="noindent">#15 Framed</p>
<p class="noindent">#16 Dangerous Plays</p>
<p class="noindent">#17 En Garde</p>
<p class="noindent">#18 Pit of Vipers</p>
<p class="noindent">#19 The Orchid Thief</p>
<p class="noindent">#20 Getting Burned</p>
<p class="noindent">#21 Close Encounters</p>
<p class="noindent">#22 Dressed to Steal</p>
<p class="noindent">#23 Troubled Waters</p>
<p class="noindent">#24 Murder on the Set</p>
<p class="noindent">#25 Trails of Treachery</p>
<p class="noindent">#26 Fishing for Clues</p>
<p class="noindent">#27 Intruder</p>
<p class="noindent">#28 Mardi Gras Masquerade</p>
<p class="noindent">#29 The Stolen Bones</p>
<p class="noindent">#30 Pageant Perfect Crime</p>
<p class="noindent">#31 Perfect Cover</p>
<p class="centera"><strong>Available from Aladdin Paperbacks</strong></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?1a6a795e